import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sends a GA4 page_view event on every client-side (SPA) route change.
 * The initial page load is already tracked by the gtag('config') call in
 * public/index.html, so the first render is skipped to avoid duplicates.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search + location.hash,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
